module.exports = __webpack_public_path__ + "static/img/BZ.f0141514.svg";